import { IAppState } from '../../redux';
import { selectActiveServiceId } from '../publishTerms';
import { selectIsAuctionBetEnabled } from './selectIsAuctionBetEnabled';
import { selectIsAutobrokerEnabled } from './selectIsAutobrokerEnabled';

export function selectIsAuctionEnabled(state: IAppState): boolean {
  const isAuctionBetEnabled = selectIsAuctionBetEnabled(state);
  const isAutobrokerEnabled = selectIsAutobrokerEnabled(state);
  const selectedServiceId = selectActiveServiceId(state);

  return (isAuctionBetEnabled || isAutobrokerEnabled) && selectedServiceId !== 'servicePackage';
}
